<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> Set Mark Entry Due Date </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
            persistent-hint hint="Please select academic year" />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getAssTypeDueDateInfo();
              getassessmentschemedetails();
            " persistent-hint hint="Please select standard" @click="putnull" />
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="assessment_detail_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="assessment_detail" return-object
            :items="assessment_detail_list" item-text="assessmenttype" label="Assessment Scheme Details" outlined
            persistent-hint hint="Please select assessment scheme type" />
        </v-col>
        <v-col cols="12" sm="3" md="3" v-if="assessment_detail != null">
          <v-icon color="error" class="ml-3">*</v-icon>

          <!-- <input
            class="mt-7 ml-2 pt-0"
            id="datePickerId"
            type="date"
            v-model="due_date"
          /> -->
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense v-model="due_date" v-bind="attrs" v-on="on" label=" Due Date" prepend-icon="event"
                hint="This Date Is Inclusive" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="due_date" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && assessment_detail && due_date">
          <v-btn class="mt-6 button" @click="setDueDate()" :loading="fetch_loader">Save / Update</v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="marks_scheduling_detail_list != ''">
        <v-col cols="12" sm="12" md="12">
          <v-data-table :headers="headers" :items="marks_scheduling_detail_list" class="elevation-1 mytable"
            :items-per-page="-1" dense></v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      overlay: false,
      selected: [],
      snackbar: false,
      marks_scheduling_detail_list: [],
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      std_div_list: null,
      sel_std_data: null,
      semester_list: null,
      sem: null,
      fetch_loader: false,
      assessment_detail_list: [],
      assessment_detail: null,
      due_date: null,
      show: false,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        {
          text: "Academic Year",
          sortable: false,
          value: "ay",
        },
        {
          text: "Standard",
          sortable: false,
          value: "std",
        },
        {
          text: "Assessment Type",
          sortable: false,
          value: "ass_type",
        },
        {
          text: "Due Date",
          sortable: false,
          value: "due_date",
        },
      ],
    };
  },

  methods: {
    putnull() {
      this.marks_scheduling_detail_list = [];
    },
    setDueDate() {
      const data = {
        ay: this.sel_ay_data.ay_id,
        std: this.sel_std_data.std_id,
        ass_type: this.assessment_detail,
        due_date: this.due_date,
      };
      axios
        .post("/Examination/saveAssTypeDueDateInfo", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Due date set Successfully...");
            this.getAssTypeDueDateInfo();
          }
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          (this.assessment_detail = null), (this.due_date = null);
        });
    },
    getAssTypeDueDateInfo() {
      const data = {
        ay: this.sel_ay_data.ay_id,
        std: this.sel_std_data.std_id,
      };
      axios
        .post("/Examination/getAssTypeDueDateInfo", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.marks_scheduling_detail_list =
              res.data.marks_scheduling_detail_list;
          }
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getassessmentschemedetails() {
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
      };
      axios
        .post("/Examination/getAssType", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.assessment_detail_list = res.data.assessment_detail_list;
          }
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          //     this.sel_ay_data = res.data.curr_ay;
          this.semester_list = res.data.sem_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.t-row {
  padding: 1rem i !important;
}

.delete-avatar {
  transition: 0.3s;
  border: 1px solid red;
  margin: 0.2rem !important;
}
.delete-avatar:hover {
  background-color: transparent;
}
.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}
.delete-v-icon:hover {
  color: white;
}
.v-dialogss {
  bottom: 880;
  right: 0;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  img {
    width: 100% !important;
  }
  body,
  tr,
  th,
  td {
    font-size: small !important;
    font-weight: bold !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 15.5in 15.5in;
  }
  table,
  td,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    font-weight: bold !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }
}
</style>
